export const drawerInjectionKey = 'Drawer'
